import { createAction, props } from '@ngrx/store';
import { INotificationMessage } from '@boma/shared/entities';
import { ExcludableList } from '@boma/shared/entities';
import { MessageEventType } from '@boma/shared/entities';
import { IPaginatedResponse } from '@boma/supplier-portal/shared/entities';

export const loadNotificationMessages = createAction(
  '[NotificationMessages] Load NotificationMessages',
  props<{
    page: number;
    pageSize: number;
    messageEventTypes: ExcludableList<MessageEventType>;
    refresh: boolean;
  }>()
);

export const loadNotificationMessagesSuccess = createAction(
  '[NotificationMessages] Load NotificationMessages Success',
  props<{ data: IPaginatedResponse<INotificationMessage>; refresh: boolean }>()
);

export const loadNotificationMessagesFailure = createAction(
  '[NotificationMessages] Load NotificationMessages Failure',
  props<{ error: any }>()
);

export const loadLatestMessages = createAction(
  '[NotificationMessages] Load NotificationMessages'
);

export const loadLatestMessagesSuccess = createAction(
  '[NotificationMessages] Load Latest Messages Success',
  props<{ data: IPaginatedResponse<INotificationMessage> }>()
);

export const loadLatestMessagesFailure = createAction(
  '[NotificationMessages] Load Latest Messages Failure',
  props<{ error: any }>()
);

export const addNotificationMessagesEvents = createAction(
  '[NotificationMessage] Add message events',
  props<{
    messages: { messageId: string; eventType: MessageEventType }[];
  }>()
);

export const addNotificationMessagesEventsSuccess = createAction(
  '[NotificationMessage] Add message events success',
  props<{ payload: INotificationMessage[] }>()
);

export const addNotificationMessagesEventsFailure = createAction(
  '[NotificationMessage] Add message events success',
  props<{ error: any }>()
);
